<template>
  <div
    class="login_content"
    :style="'background:' + backgroundImage + ' center'"
  >
    <div class="box-card">
      <div style="text-align: center;">
        <div style="font-size: 28px;margin-bottom: 20px;color:white">
          {{ pageTitle }}
        </div>
      </div>
      <div style="width: 330px;margin: 0 auto;padding-bottom: 20px">
        <h3>登录</h3>
        <a-form
          id="components-form-demo-normal-login"
          :form="form"
          class="login-form"
          @submit="handleSubmit"
        >
          <a-form-item label="" style="margin-bottom: 20px">
            <a-input placeholder="请输入用户名..." v-decorator="['username']">
              <a-icon
                slot="prefix"
                type="user"
                style="color: rgba(0,0,0,.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item label="">
            <a-input
              type="password"
              placeholder="请输入密码..."
              v-decorator="['password']"
            >
              <a-icon
                slot="prefix"
                type="lock"
                style="color: rgba(0,0,0,.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item style="text-align: right">
            <a-checkbox
              v-decorator="[
                'remember',
                {
                  valuePropName: 'checked',
                  initialValue: true
                }
              ]"
            >
              <span style="color:white">记住密码</span>
            </a-checkbox>

            <a-button
              type="primary"
              html-type="submit"
              class="login-form-button"
            >
              登录
            </a-button>
          </a-form-item>
        </a-form>
      </div>
      <p style=" margin: 50px 0; color: #888;text-align: center;">
        <!-- Copyright © 2014- {{year}} 山东诺方电子科技有限公司 -->
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { login, getClient, getProjectName } from "@/api/api";
import { mapState, mapGetters } from "vuex";
import Config from "@/config";

export default {
  name: "App",
  data() {
    return {
      msg: "hello",
      username: "",
      password: "",
      remember: false,
      backgroundImage: `url(${require("@/assets/bg2.png")})`
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  mounted() {
    if (localStorage.username && localStorage.password) {
      this.form.setFieldsValue({ username: localStorage.username });
      this.form.setFieldsValue({ password: localStorage.password });
      this.remember = true;
    } else {
      this.form.setFieldsValue({ username: "" });
      this.form.setFieldsValue({ password: "" });
      this.remember = false;
    }
  },
  computed: {
    ...mapGetters(["pageTitle"]),
    ...mapState(["clientInfo"]),
    year() {
      var date = new Date();
      var year = date.getFullYear();
      return year;
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          getClient(values.username)
            .then(c => {
              if (c.data.code !== 200) {
                this.$message.error(c.data.msg);
                return;
              }
              this.$store.commit("setClientInfo", c.data.data);

              let data = {
                username: values.username,
                password: values.password,
                grant_type: "password",
                client_id: this.clientInfo.clientId,
                client_secret: this.clientInfo.clientSecretStr
              };
              login(data)
                .then(d => {
                  console.log(d);
                  if (d.data.access_token) {
                    let token = d.data.access_token;
                    sessionStorage.setItem(Config.TOKEN_KEY, token);
                    this.$store.commit("setToken", token);
                    localStorage.setItem("yc_token", token);
                    this.$message.success("登陆成功");

                    if (values.remember) {
                      localStorage.setItem("username", values.username);
                      localStorage.setItem("password", values.password);
                    } else {
                      localStorage.removeItem("username");
                      localStorage.removeItem("password");
                    }

                    this.$store.dispatch("init", () => {
                      this.$router.replace({ name: "home" });
                    });
                  } else {
                    this.$message.error("登录失败");
                  }
                })
                .catch(e => {
                  console.log(e);
                  if (e.response) {
                    this.$message.error(e.response.data.msg || "登录失败");
                  } else {
                    this.$message.error("登录失败");
                  }
                });
            })
            .catch(e => {
              console.log(e);
              this.$message.error(e.response.data.msg || "登录失败");
            });
        }
      });
    }
  }
};
</script>

<style lang="less">
.login_content {
  height: 100vh;
  width: 100vw;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-color: white;
}

.box-card {
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 45%;
  width: 400px;
}
#components-form-demo-normal-login .login-form {
  max-width: 300px;
}
#components-form-demo-normal-login .login-form-forgot {
  float: right;
}
#components-form-demo-normal-login .login-form-button {
  width: 100%;
}

.ant-input {
  background-color: #3e343433 !important;
  color: white !important;
  border: 1px solid #5cafff !important;
}

.ant-input-prefix > i {
  color: #5cafff !important;
}
</style>
